import { useEffect, useState } from 'react'
import api from '../../services/api'

import './styles.css'

import NavBar from '../../components/NavBar/NavBar.js'
import SideBar from '../../components/SideBar'
import CorpoReport from '../../components/CorpoBackups/ReportSemanaAll'

function ReportSemanalAvulso() {
    const [body, setBody] = useState([])

    const getData = async () =>{
        await api.get('/empresas?ativa=1').then((response) => {
           const respost = response.data
           setBody(respost)
         })
       }
       useEffect(() => {
         getData()
       }, [])
    const data1 = new Date().toLocaleDateString()
    const splidData = data1.split('/')
    let dia = splidData[0]
    let mes = splidData[1]
    let ano = splidData[2]
    return (
        <NavBar>
            {body
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((body) => {
                    if (body.contrato != "Contrato")
                        return (
                            <CorpoReport key={body.id} data={body} dia={dia} mes={mes} ano={ano} />
                        )
                })}
            <br />
        </NavBar>
    )
}

export default ReportSemanalAvulso
